export default __webpack_public_path__ + "static/3-7b84a6af7d033c3f610018f9e1153a34.jpeg";